// extracted by mini-css-extract-plugin
export default {"metricsGroup":"DCoFbVHFvyVa1d5XX3Qu"};